export type MenuState = {
	isResponsiveMenuOpen: boolean;
	toggleResponsiveMenuOpen: () => void;
	offcanvas: string | null;
	openOffcanvas: (id: string) => void;
	closeOffcanvas: () => void;
	resetMenuSlice: () => void;
};

type SetStateFunction = (
	partial: Partial<MenuState> | ((state: MenuState) => Partial<MenuState>),
) => void;

const initialMenuState: Pick<MenuState, 'isResponsiveMenuOpen' | 'offcanvas'> = {
	isResponsiveMenuOpen: false,
	offcanvas: null,
};

const createMenuSlice = (set: SetStateFunction): MenuState => ({
	...initialMenuState,
	toggleResponsiveMenuOpen: () =>
		set((state) => ({
			isResponsiveMenuOpen: !state.isResponsiveMenuOpen,
		})),

	openOffcanvas: (id) =>
		set(() => ({
			offcanvas: id,
		})),

	closeOffcanvas: () =>
		set(() => ({
			offcanvas: null,
		})),

	resetMenuSlice: () => set(() => initialMenuState),
});

export { createMenuSlice };
